import { Grid } from '@material-ui/core';
import { useFormState } from 'react-final-form';
import _ from 'lodash';
import QCXSelectFundamentoLegalRegimeTributacaoIiAutocomplete from '../../../../shared-components/select-fundamento-legal-regime-tributacao-ii/QCXSelectFundamentoLegalRegimeTributacaoIiAutocomplete';
import QCXSelectRegimeTributacaoAutocomplete from '../../../../shared-components/select-regime-tributacao/QCXSelectRegimeTributacaoAutocomplete';

export default function FundamentoLegal({ metadado, isConsult, basePath = '', ncm = false, ...restProps }) {
  const { values } = useFormState();

  return (
    <>
      <Grid item xs={12} sm={6} md={4}>
        <QCXSelectFundamentoLegalRegimeTributacaoIiAutocomplete
          id="autocomplete-select-fundamento-legal-regime-tributacao-ii-field"
          key="autocomplete-select-fundamento-legal-regime-tributacao-ii-field"
          name={`atributosAdicionais.lpcoForm.jsonFormulario.ncm.dados.${metadado?.codigo}.valor`}
          label="Fundamento Legal"
          initialValues={values}
          disabled={isConsult}
          isDuimp
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <QCXSelectRegimeTributacaoAutocomplete
          id="autocomplete-select-regime-tributacao-field"
          key="autocomplete-select-regime-tributacao-field"
          name="atributosAdicionais.lpcoForm.jsonFormulario.ncm.dados.REGIME_TRIBUTACAO.valor"
          label="Regime de Tributação"
          initialValues={values}
          disabled={isConsult}
        />
      </Grid>
    </>
  );
}
